// extracted by mini-css-extract-plugin
export var searchIcon = "styles-module--searchIcon--4TOtk";
export var searchSvg = "styles-module--searchSvg--c59wE";